import { render, staticRenderFns } from "./EquipamientoGrid.vue?vue&type=template&id=78a13031"
import script from "./EquipamientoGrid.vue?vue&type=script&lang=js"
export * from "./EquipamientoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports